/**
 *  알림톡 발송 내역 조회 에러 코드 (백엔드 apps/admin common/constants/response/error — ALIMTALK_SEND 그룹)
 *  코드·메시지는 백엔드와 1:1 로 맞춘다.
 */
export const ALIMTALK_SEND_ERROR_CODE = {
  ALIMTALK_SEND_003: 'ALIMTALK_SEND003',
  ALIMTALK_SEND_004: 'ALIMTALK_SEND004',
  ALIMTALK_SEND_005: 'ALIMTALK_SEND005',
  ALIMTALK_SEND_006: 'ALIMTALK_SEND006',
  ALIMTALK_SEND_007: 'ALIMTALK_SEND007',
  ALIMTALK_SEND_008: 'ALIMTALK_SEND008',
};

const ALIMTALK_SEND_ERROR_MESSAGE = {
  [ALIMTALK_SEND_ERROR_CODE.ALIMTALK_SEND_003]: '발송 내역 조회 날짜 형식이 올바르지 않습니다.',
  [ALIMTALK_SEND_ERROR_CODE.ALIMTALK_SEND_004]: '조회 시작일이 종료일보다 늦습니다.',
  [ALIMTALK_SEND_ERROR_CODE.ALIMTALK_SEND_005]: '검색어에 사용할 검색 유형을 선택해 주세요.',
  [ALIMTALK_SEND_ERROR_CODE.ALIMTALK_SEND_006]: '예약 ID는 양의 정수여야 합니다.',
  [ALIMTALK_SEND_ERROR_CODE.ALIMTALK_SEND_007]: '페이지 또는 페이지 크기가 허용 범위를 벗어났습니다.',
  [ALIMTALK_SEND_ERROR_CODE.ALIMTALK_SEND_008]: '발송 내역을 찾을 수 없습니다.',
};

export default ALIMTALK_SEND_ERROR_MESSAGE;
